// Module-scope cache for the Braintree client token. The token is valid for
// ~24h, so we reuse it across modal opens within the page lifetime. On
// account switch the cache invalidates automatically (key mismatch); on a
// stale-token error during init the consumer calls `invalidate()` and refetches.

let cached: { accountId: string; token: string } | null = null;

export const getCachedClientToken = (accountId: string): string | null =>
  cached && cached.accountId === accountId ? cached.token : null;

export const setCachedClientToken = (
  accountId: string,
  token: string
): void => {
  cached = { accountId, token };
};

export const invalidateCachedClientToken = (): void => {
  cached = null;
};

export const resetClientTokenCacheForTests = (): void => {
  cached = null;
};
